module.exports = __webpack_public_path__ + "static/media/clean.b35fb38e.svg";